export default {
  'contactUs.title': 'Contact Us',
  'contactUs.userInfo': 'User Information',
  'contactUs.firstName': 'First Name',
  'contactUs.lastName': 'Last Name',
  'contactUs.email': 'Business Email',
  'contactUs.phone': 'Phone Number',
  'contactUs.jobTitle': 'Job Title',
  'contactUs.howCanWeHelp': 'How can we help?',
  'contactUs.companyInfo': 'Company Information',
  'contactUs.companyName': 'Company Name',
  'contactUs.companyIndustry': 'Company Industry',
  'contactUs.companySize': 'Company Size',
  'contactUs.submit': 'Submit',
  'contactUs.submitSuccess': 'Submitted successfully, we will contact you soon',
  'contactUs.submitFail': 'Submission failed',
  'contactUs.firstNameRequired': 'First name is required',
  'contactUs.lastNameRequired': 'Last name is required',
  'contactUs.emailRequired': 'Email is required',
  'contactUs.emailInvalid': 'Please enter a valid email address',
  'contactUs.phoneRequired': 'Phone number is required',
  'contactUs.phoneInvalid': 'Please enter a valid phone number',
  'contactUs.jobTitleRequired': 'Job title is required',
  'contactUs.companyNameRequired': 'Company name is required',
  'contactUs.companyIndustryRequired': 'Company industry is required',
  'contactUs.companySizeRequired': 'Company size is required',
  'contactUs.helpRequired': 'Description is required',
};
